import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n
  .use(HttpApi)
  .use(LanguageDetector) // ❗ Tarayıcı dilini algılamak için bu da olmalı
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    load: 'languageOnly', // ❗❗ Önemli satır
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;